import { render, staticRenderFns } from "./base-nav-item.vue?vue&type=template&id=4c11fcfa"
import script from "./base-nav-item.vue?vue&type=script&lang=js"
export * from "./base-nav-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports